import { HygraphWearable } from '@repo/types-client';

const maxClaimMap: { [key: string]: number } = {
  Essential: 1000,
  Exclusive: 250,
  Grail: 60,
  iconic: 3,
};

/**
 * Retrieves the maximum claimable amount for a given tier.
 * @function getMaxClaimForTier
 * @param {string} tier - The tier of the wearable.
 * @returns {number} The maximum claimable amount associated with the tier.
 */
export const getMaxClaimForTier = (tier: string): number => {
  const wearableTierMaxClaim = maxClaimMap[tier];
  if (!wearableTierMaxClaim) {
    console.error(`Invalid tier: ${tier}`);
    return 0;
  }
  return wearableTierMaxClaim;
};

/**
 * Resolves the base maximum claimable amount for a wearable template.
 * @function resolveWearableTemplateBaseMaxClaim
 * @param {HygraphWearable} wearable - The wearable object.
 * @returns {number} The base maximum claimable amount of the wearable.
 */
const resolveWearableTemplateBaseMaxClaim = (
  wearable: HygraphWearable,
): number => {
  if (wearable.maxClaimsOverride) {
    return wearable.maxClaimsOverride;
  }

  return getMaxClaimForTier(wearable.tier as string);
};

/**
 * Calculates the total maximum claimable amount for a wearable.
 * @function calculateWearableMaxClaim
 * @param {HygraphWearable} wearable - The wearable object.
 * @returns {number} The total maximum claimable amount of the wearable.
 */
export const calculateWearableMaxClaim = (
  wearable: HygraphWearable,
): number => {
  return resolveWearableTemplateBaseMaxClaim(wearable);
};
